import React, { Component } from 'react';

import './styles.less';

class CancelTrimButton extends Component {
  render() {
    const { currentTrimRange } = this.props;

    const canCancelTrim = currentTrimRange != null;

    const cancelTrimClass = canCancelTrim ? 'enabled' : '';
    const cancelTrimOnClick = canCancelTrim
      ? this.props.onCancelCurrentTrimRange
      : null;

    return (
      <div
        className={`trim-bar-button trim-bar-cancel-trim-button ${cancelTrimClass}`}
        onClick={cancelTrimOnClick}
      >
        <span className="icon" />
        <span className="label">Cancel</span>
      </div>
    );
  }
}

export default CancelTrimButton;
